<template>
  <div class="device-key-setting">
    <div class="border_title">
      {{ $t('deviceMsg.keySetting') }}
    </div>
    <div class="device-key-setting-container">
      <div class="device-key-setting-item" v-for="(item, index) in KeyList" :key="index">
        <span class="device-key-setting-item-title">
          {{ item.name }}
        </span>
        <div class="device-key-setting-item-right">
          <el-popover placement="left" width="340" trigger="click" class="el-popover-custom" :disabled="!!item.classSku">
            <ul class="opple-ability-ui-com-image-icon-enum_imglist">
              <li
                v-for="(img, i) in sceneIconList"
                :key="i"
                class="opple-ability-ui-com-image-icon-enum_img"
                :class="{ active: item.selectIndex === i }"
                @click="() => handlerIconClick(item, i)"
              >
                <img :src="img.Icon" />
              </li>
            </ul>
            <div slot="reference" class="planeBox-icon">
              <div class="opple-ability-ui-com-image-icon-enum_icon">
                <img :src="item.Icon" />
                <img src="../../assets/img/edit.png" class="edit" v-if="!!!item.classSku" />
              </div>
            </div>
          </el-popover>
          <el-input
            v-model="item.keyName"
            :placeholder="$t('deviceMsg.keyInput')"
            style="width: 200px"
            @input="changeInput(item)"
            :disabled="!!item.classSku"
          />
        </div>
      </div>
      <button class="paramSaveBlue paramSave save-btn" @click="savesubmit" :class="isChange ? 'change' : 'gray'">
        {{ $t('deviceMsg.savesubmit') }}
      </button>
    </div>
  </div>
</template>
<script>
//按键设置组件
import { GetImageList, getSwitchKeyEventList, setSwitchKeyName } from '@/axios/IFttt.js'
import { GetClassskuList } from '@/axios/IMonitor.js'
import { FindTriggerAbility, FindDeviceAbilityByVDeviceId } from '@/axios/IDevice.js'
import { alertsuccess } from '@/assets/js/common.js'

const KEYSETTING = {
  smart: 1, //智能灯
  notSmart: 0, //非智能灯
  notSet: 2, //未设置
}
export default {
  props: {
    device: {
      type: Object,
      default: () => ({}),
    },
    GpList: {
      type: Array,
      default: () => [],
    },
    webInnoConfig: {
      type: Array,
      default: () => [],
    },
    ActionList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    //判断是否修改过
    isChange() {
      return this.KeyList.some(item => item.change)
    },
  },
  watch: {
    GpList: {
      handler() {
        this.checkClassSku(this.KeyList)
      },
      deep: true,
    },
  },
  data() {
    return {
      KeyEventList: [],
      allClassList: {},
      KeyList: [],
      TriggerList: [],
      sceneIconList: [],
      allActionList: [], // 下发过的所有的能力表
    }
  },
  async mounted() {
    this.getImageList()
    this.handleGpList()
  },
  methods: {
    //获取图片列表
    async getImageList() {
      try {
        const res = await GetImageList()
        this.sceneIconList = (res.Result || []).map(item => ({
          ...item,
          HIcon: `${item.FileUrl}+2`,
          Icon: `${item.FileUrl}+3`,
        }))
      } catch (e) {}
    },

    //获取已配置的按键列表
    async getKeyEventList() {
      try {
        const res = await getSwitchKeyEventList({
          vDeviceId: this.device.VDeviceId,
          type: 1,
        })
        const res1 = await getSwitchKeyEventList({
          vDeviceId: this.device.VDeviceId,
          type: 0,
        })
        if (res.StatusCode == 0 || res1.StatusCode == 0) {
          this.KeyEventList = (res?.Result || []).concat(res1?.Result || [])
          const keyEvent = this.KeyList.filter(key => {
            //找出智能灯&&未配置的按键 且 没有从关联配置中找到相应的
            return !this.getKeyIsSmart(key) && !this.getKeyFromGp(key)
          })
          keyEvent.forEach(item => {
            const key = this.KeyEventList.filter(key => item.MsgType.indexOf(key.MessageType) >= 0) //找出所有的按键
            if (key && key.length > 0) {
              let hasMacth = false
              key.forEach(_key => {
                const { Type, NameId, KeyEvent } = _key // 0 action ，1 trigger  trigger msgtype 相同
                
                if (item.saveType == Type && NameId == item.NameId) {
                  if (_key.hasOwnProperty('KeyEvent')) {
                    
                    if (KeyEvent == item.KeyEvent) {
                      item.keyName = _key.Name
                      item.Icon = _key.Icon
                      item.HIcon = _key.HIcon
                      hasMacth = true
                    }
                  } else {
                    item.keyName = _key.Name
                    item.Icon = _key.Icon
                    item.HIcon = _key.HIcon
                    hasMacth = true
                  }
                }
              })
              if (!hasMacth) {
                item.keyName = this.$t('deviceMsg.unSetting')
              }
            } else {
              item.keyName = this.$t('deviceMsg.unSetting')
            }
          })
        }
      } catch (e) {
        console.log('....获取已配置的按键列表', e)
      }
    },
    handlerIconClick(item, index) {
      item.selectIndex = index
      item.Icon = this.sceneIconList[index].Icon
      item.HIcon = this.sceneIconList[index].HIcon
      item.change = true
    },
    //获取触发器列表
    async getTriggerList() {
      try {
        if (this.TriggerList.length > 0) return
        const res = await FindTriggerAbility({
          VDeviceId: this.device.VDeviceId,
        })
        if (res.StatusCode == 0) {
          this.TriggerList = res.Result?.TriggerList || []
        }
      } catch (e) {
        console.log('.....获取触发器列表errror', e)
      }
    },
    // 获取所有的能力表
    async getActionList() {
      try {
        const res = await FindDeviceAbilityByVDeviceId({
          VDeviceId: this.device.VDeviceId,
        })
        if (res.StatusCode == 0) {
          this.allActionList = res.Result?.ActionSet?.[0]?.ActionList || []
        }
      } catch (e) {
        console.log('.....获取触发器列表errror', e)
      }
    },
    /**
     * 保存
     */
    async savesubmit() {
      try {
        if (!this.isChange) return
        const list = this.KeyList.filter(item => item.change).map(info => {
          this.matchMsgType(info)
          const _info = {
            VDeviceId: this.device.VDeviceId,
            Name: info.keyName,
            Icon: info.Icon || '',
            HIcon: info.HIcon || info.Icon || '',
            Type: info.saveType,
            MessageType: info.MsgType,
            NameId: info.NameId || 0,
          }
          if (_info.Type == 1) {
            _info.KeyEvent = Number(info.KeyEvent)
          }
          return _info
        })
        const req = {
          DeviceSwitchKeyNames: list,
        }
        const res = await setSwitchKeyName(req)
        if (res.StatusCode == 0) {
          alertsuccess(this, res.StatusCode)
          this.KeyList.forEach(item => {
            //保存成功后,修改状态
            if (item.change) {
              item.fromGp = false
            }
            item.change = false
          })
          this.getKeyEventList()
        }
      } catch (error) {
        console.log('保存error', error)
      }
    },
    /**
     * 处理keylist
     */
    handleGpList() {
      try {
        if (this.webInnoConfig && this.webInnoConfig.length > 0) {
          this.KeyList = this.webInnoConfig.map((item, index) => {
            const { name } = item
            return {
              ...item,
              name,
              selectIndex: -1,
              Icon: '',
              HIcon: '',
              keyName: '',
              change: false, //是否修改过按键名称
            }
          })
          this.checkClassSku(this.KeyList)
        }
      } catch (error) {
        console.log('.....errror', error)
      }
    },
    //修改按键名称
    changeInput(item) {
      item.change = true
    },

    //判断按键继电器是否智能灯 && 非智能灯 && 未配置
    /**
     *
     * @param item
     * 返回 true 代表非智能灯
     */
    getKeyIsSmart(item) {
      const { defalutGpCondition, type } = item
      if (type == 'config') {
        return false
      }
      const { GpNo, GpKeyId } = defalutGpCondition
      const info = this.GpList.find(gp => gp.GpNo == GpNo)?.GpDetails.find(detail => detail.KeyId == GpKeyId)
      if (info) {
        const { DefaultValue } = info
        const DefaultValue_ = parseInt(DefaultValue)
        return DefaultValue_ === KEYSETTING.notSmart
      }
      return false
    },
    /**
     * 判断按键名字icon是否在关联配置里面找到
     * @param item
     */
    getKeyFromGp(item) {
      const { nameIconGpCondition } = item
      const { GpNo, GpKeyId } = nameIconGpCondition
      const info = this.GpList.find(gp => gp.GpNo == GpNo)?.GpDetails.find(detail => detail.KeyId == GpKeyId)
      //找到相应的名字icon
      if (info) {
        const { DefaultValue, UI } = info
        if (UI && UI.EnumValueMap && UI.EnumValueMap[DefaultValue]) {
          return true
        }
      }
      return false
    },
    /**
     * 检查按键是否绑定classsku ,批量查询
     */
    async checkClassSku(list) {
      try {
        await this.getTriggerList()
        await this.getActionList()
        const classSkuList = []
        const action_list = this.ActionList.flatMap(action => action.ActionList)
        list.forEach(item => {
          const { relevanceGpCondition, type } = item
          if (type == 'config') {
            this.matchMsgType(item, true)
            return
          }
          if (this.GpList) {
            const { GpNo, GpKeyId } = relevanceGpCondition
            const info = this.GpList.find(gp => gp.GpNo == GpNo)?.GpDetails.find(detail => detail.KeyId == GpKeyId)
            if (info) {
              const { DefaultValue } = info
              const DefaultValue_ = parseInt(DefaultValue)
              if (DefaultValue_ != 0) {
                //获取classsku
                const classSku = '0x' + DefaultValue
                item.classSku = classSku // 按键是否直达灯具
                classSkuList.push(classSku)
              }
              const action = action_list.find(action => action.Code == item.actionCode)
              //直连灯具,能力表不能切换开关
              if (action && action.Values) {
                action.Values.filter(item => item.IsShow).forEach(item => {
                  item.disabled = DefaultValue_ != 0
                })
              }
            }
          }
          this.matchMsgType(item, true)
        })
        if (classSkuList.length > 0) {
          await this.getClassSku(classSkuList)
        }
        this.getKeyEventList()
      } catch (error) {
        console.log('查按键是否绑定classskue------error', error)
      }
    },
    /**
     * 获取classsku信息
     */
    async getClassSku() {
      try {
        if (Object.keys(this.allClassList).length == 0) {
          const res = await GetClassskuList()
          const { Result, StatusCode } = res
          if (StatusCode == 0 && Array.isArray(Result)) {
            Result.forEach(item => {
              this.allClassList[item.ClassSku] = item
            })
          }
        }
        this.KeyList.forEach(item => {
          if (item.classSku) {
            const classInfo = this.allClassList[item.classSku]
            if (classInfo) {
              item.Icon = classInfo.IconUrl?.Figure
              item.keyName = classInfo.Name
            }
          }
        })
      } catch (error) {
        console.log('getClassSku------error', error)
      }
    },

    /**
     * 处理gplist数据
     * icon name 查找:
     * 智能灯, 未接灯具
     * 绑定的自动化 trigger不显示icon 显示未设置
     * 直连灯具,会从gplist中找到关联对象,然后通过classskuid找到对应的icon,名称
     *
     *
     * 非智能灯,
     * 从action中找到关联对象
     * 绑定的非智能灯 从action中找到关联对象 然后通过classskuid找到对应的icon,名称
     */

    /**
     * 匹配相应的msgtype 按键1,2,3从action中拿
     * 按键4从trgigger中拿
     * nameId ChannelId 或 PhyPosition ；action 传 ChannelId ，trigger 传 PhyPosition
     * type  类型，区分action和trigger 0 action ，1 trigger
     * @param overName 初始化 覆盖名字,icon
     */
    matchMsgType(item, overName = false) {
      try {
        const { type, actionCode, triggerCode, classSku, nameIconGpCondition } = item
        //继电器为智能灯时,取trigger
        const func_trigger = () => {
          const trigger = this.TriggerList.find(trigger => trigger.Code == triggerCode)
          if (trigger) {
            item.MsgType = trigger.MsgID
            item.NameId = trigger.PhyPosition
            item.KeyEvent = trigger.DefaultValue
            item.saveType = 1
          }
          if (overName) {
            const { GpNo, GpKeyId } = nameIconGpCondition
            const info = this.GpList.find(gp => gp.GpNo == GpNo)?.GpDetails.find(detail => detail.KeyId == GpKeyId)
            //找到相应的名字icon
            if (info) {
              const { DefaultValue, UI } = info
              if (UI && UI.EnumValueMap && UI.EnumValueMap[DefaultValue]) {
                const { Name, icon } = UI.EnumValueMap[DefaultValue]
                item.Icon = icon
                item.keyName = Name
                item.fromGp = true //是否从gplist中找到的
              }
            }
          }
        }
        //继电器为非智能灯时,取action
        const func_action = () => {
          const action_list = this.allActionList
          const action = action_list.find(action => action.Code == actionCode)
          if (action) {
            item.MsgType = action.MsgType
            item.NameId = action.ChannelId
            item.saveType = 0
            // 没有直连设备
            if (overName && !Boolean(classSku)) {
              item.keyName = action?.CnDesc || action?.Desc
              item.Icon = action?.UI?.Icon_n
            }
          }
        }
        if (type == 'config') {
          func_trigger()
          return
        }
        if (!!classSku) {
          func_action()
        } else {
          const { defalutGpCondition } = item
          const { GpNo, GpKeyId } = defalutGpCondition
          const info = this.GpList.find(gp => gp.GpNo == GpNo)?.GpDetails.find(detail => detail.KeyId == GpKeyId)
          if (info) {
            const { DefaultValue } = info
            const DefaultValue_ = parseInt(DefaultValue)
            //非智能灯走action
            if (DefaultValue_ === KEYSETTING.notSmart) {
              func_action()
            } else {
              func_trigger()
            }
          }
        }
      } catch (error) {
        console.log('matchMsgType------error', error)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.device-key-setting {
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;

    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: '';
      position: absolute;
      left: 0;
      height: 16px;
    }
  }
  .device-key-setting-container {
    display: flex;
    width: 100%;
    padding: 19px 0px 60px 0px;
    border: 1px solid #e0e3e6;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
    .device-key-setting-item {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 20px 0px;
      box-sizing: border-box;
      .device-key-setting-item-title {
        font-weight: 400;
        font-size: 14px;
        color: #606266;
        line-height: 17px;
      }
      .device-key-setting-item-right {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 100px;
      }
    }
    .save-btn {
      bottom: 20px;
    }
  }
}
.el-popover-custom,
.opple-ability-ui-com-image-icon-enum_img {
  img {
    width: 36px;
    height: 36px;
  }
}

.opple-ability-ui-com-image-icon-enum_icon {
  position: relative;

  .edit {
    position: absolute;
    right: 0;
    top: 0px;
    width: 18px;
    height: 14px;
  }
}

.gray {
  opacity: 0.5;
  border: solid 1px #c6c6c6;
  color: #c6c6c6;
}

.gray:hover {
  cursor: not-allowed;
  border: solid 1px #c6c6c6;
  color: #c6c6c6;
  background: #fff;
}

.change {
  opacity: 1;
}
</style>
